import moment, { Moment } from 'moment';
import { Allocation, ResourceType } from 'api/resource-management/types';
import { defaultFormat } from 'utils/date-field/formatter';
import type { TemplateAllocation } from '../types';
import { weekendHighlightAsUIFormatForTemplate } from './weekend-highlight-for-template';
import {
  AllWorkingDayConfig,
  getDateAfterSomeNumberOfWorkingDays,
} from './working-days';

export const asTemplateAllocation =
  (relativeDate: Moment, isHoursPerWeek?: boolean) =>
  (allocation: Allocation): TemplateAllocation => {
    let adjStartDate = allocation.startDate;
    let adjEndDate = allocation.endDate;

    if (isHoursPerWeek) {
      const allocationStartDate = moment(allocation.startDate);
      const startDate = allocationStartDate.diff(relativeDate, 'days');
      const allocationEndDate = moment(allocation.endDate);
      const adjDuration =
        allocationEndDate.diff(allocationStartDate, 'days') + 1;
      const adjustedStartDate = getDateAfterSomeNumberOfWorkingDays(
        relativeDate,
        startDate,
        AllWorkingDayConfig,
      );
      const adjustedEndDate = getDateAfterSomeNumberOfWorkingDays(
        adjustedStartDate,
        adjDuration - 1,
        AllWorkingDayConfig,
      );

      adjStartDate = defaultFormat(adjustedStartDate);
      adjEndDate = defaultFormat(adjustedEndDate);
    }

    const startDay = moment(adjStartDate).diff(relativeDate, 'day');
    const duration = moment(adjEndDate).diff(moment(adjStartDate), 'day') + 1;

    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    let weekendHighlightForUI: TemplateAllocation['weekendHighlightForUI'] = [];

    if (isHoursPerWeek) {
      weekendHighlightForUI = weekendHighlightAsUIFormatForTemplate(
        relativeDate,
        startDay,
        duration,
        allocation.includeSaturday ?? false,
        allocation.includeSunday ?? false,
      );
    }

    return {
      id: allocation.id,
      minutes: allocation.minutes,
      projectPhaseId: allocation.projectPhaseId,
      billable: allocation.billable,
      startDay,
      duration,
      medium: allocation.medium,
      ...(allocation.type === ResourceType.User
        ? { type: ResourceType.User, userId: allocation.userId }
        : { type: ResourceType.Team, teamId: allocation.teamId }),
      sources: allocation.sources,
      includeSaturday: allocation.includeSaturday,
      includeSunday: allocation.includeSunday,
      // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
      weekendHighlightForUI,
    };
  };
